import { ref } from "vue";
import { BenPlayerApi } from "@/api-connector/ben-be-player/methods/ben-player-api";
import { PlayerApi } from "@/api-connector/ls-admin-public/metods/player-api";
import { isMobileApp, triggerMobileAppEvent } from "@sazka/mobile-apps/mobile-app-integration";
import { PlayerWalletModel } from "./models/player-wallet-model";
import useUserAccount, { clientId } from "./use-user-account";

const defaultWalletDataValues = {
    availableSpins: 0,
    draws: null,
    withdrawableAmount: 0,
    withdrawalExpiration: "",
};

const userWalletData = ref<PlayerWalletModel>(defaultWalletDataValues);

const { waitForUserAccount, addOnLoginCallback } = useUserAccount();

const loadUserWalletData = async () => {
    if (isMobileApp) {
        triggerMobileAppEvent("refreshBalance");
        return;
    }

    try {
        await waitForUserAccount();
        if (!clientId.value) {
            return;
        }
        const accountStatusPromise = PlayerApi.fetchPlayerAccountStatus(clientId.value);
        const playerWalletPromise = BenPlayerApi.fetchPlayerWallet(clientId.value);

        const [accountStatus, playerWallet] = await Promise.all([accountStatusPromise, playerWalletPromise]);
        userWalletData.value = { ...accountStatus, ...playerWallet };
    } catch (err: unknown) {
        console.error(err);
    }
};

addOnLoginCallback(loadUserWalletData);

export function useUserData() {
    return {
        userWalletData,
        loadUserWalletData,
    };
}
